import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';

import { registerLocaleData } from '@angular/common';
import { AppModule } from './app/app.module';

import { APP_CONFIG_TOKEN } from './app/shared/utils/app-config.token';

import localePl from '@angular/common/locales/pl';
import { IConfig } from './app/core/interfaces/app-config.interface';
import checkBrowser from './app/core/utils/browser-check';
import { environment } from './environments/environment';
import './icons';
import 'hammerjs';

registerLocaleData(localePl, 'pl');

if (environment.production) {
  enableProdMode();
}

fetch(`${environment.configUrl}?t=${new Date().getTime()}`)
  .then((res) => res.json())
  .then((config: IConfig) => {
    checkBrowser(config.disallowedBrowsers);
    // EventEmitter.defaultMaxListeners = 20;
    // EventEmitter.setMaxListeners(20);
    if (!!config.sentry && config.sentry.enabled) {
      Sentry.init({
        dsn: config.sentry.dsn,
        integrations: [
          Sentry.browserTracingIntegration(),
          Sentry.replayIntegration(),
        ],
        // Tracing
        tracesSampleRate: config.sentry.tracesSampleRate, //  Capture 100% of the transactions 1.0 or 0
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: config.sentry.tracePropagationTargets,
        // Session Replay
        replaysSessionSampleRate: config.sentry.replaysSessionSampleRate,
        // This sets the sample rate at 10%. You may want to change it to 100%
        // while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: config.sentry.replaysOnErrorSampleRate,
        // If you're not already sampling the entire session, change the
        // sample rate to 100% when sampling sessions where errors occur.
      });
    }

    platformBrowserDynamic([{ provide: APP_CONFIG_TOKEN, useValue: config }])
      .bootstrapModule(AppModule)
      .catch((err) => console.log(err));
  });
